import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM7 6.04V11.96C7 12.38 7.48 12.61 7.81 12.35L11.51 9.39C11.76 9.19 11.76 8.81 11.51 8.61L7.81 5.65C7.48 5.39 7 5.62 7 6.04ZM3 16H15C15.55 16 16 15.55 16 15V3C16 2.45 15.55 2 15 2H3C2.45 2 2 2.45 2 3V15C2 15.55 2.45 16 3 16Z";

export default function SlideShowIcon(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      {...props}
      fillRule="evenodd"
      viewBox="0 0 24 19"
      clipRule="evenodd"
    />
  );
}
